export default "__VITE_ASSET__CFFmTdj1__"